import { MDBTypography, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

export default function NewsContactSection({
  newsData,
  employee,
  toggleSelectEmployeeModal,
  getFieldError,
  markFieldTouched,
}) {
  const { t } = useTranslation();
  const employeeError = getFieldError('cMSNewsEmployeeId');

  return (
    <>
      <div className="mb-2 mb-lg-4">
        <MDBTypography tag="h6" className="text-muted">
          {t("Choose a contact person who interested parties can contact regarding the news article")}
        </MDBTypography>
      </div>
      <div className="w-100 text-center">
        <MDBBtn
          onClick={() => { markFieldTouched('cMSNewsEmployeeId'); toggleSelectEmployeeModal(); }}
          color="primary"
          outline
        >
          {t("Select employee")}
        </MDBBtn>
        {employeeError && (
          <div className="text-danger small mt-2">
            {employeeError}
          </div>
        )}
        {employee && (
          <div className="d-flex gap-4 align-items-center mt-3">
            {employee.image?.fileName ? (
              <img
                src={`https://iec-cp-public.s3.eu-central-1.amazonaws.com/userImages/${employee.image.fileName}`}
                className="rounded-circle border"
                style={{ height: "50px", width: "50px", objectFit: "cover" }}
                alt={employee.image.alt}
              />
            ) : (
              <MDBIcon
                className="rounded-circle border d-flex align-items-center justify-content-center"
                style={{ height: "50px", width: "50px", fontSize: "20px" }}
                fas
                icon="user-alt"
              />
            )}
            <div className="text-start">
              <h6 className="mb-0">
                {`${employee.user?.title ? employee.user.title + " " : ""}${employee.user?.firstName} ${employee.user?.middleName || ""} ${employee.user?.lastName}`}
              </h6>
              <span className="text-muted">
                {employee.department?.items?.[0]?.department.name[0].text}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
